import { useState, useEffect, useReducer } from "react";
import socket from "../../../../../../socket-io.js";
import "./POSExecutions.css";
import { useSelector } from "react-redux";
import axios from "axios";
import { useDispatch } from "react-redux";
import { useSnackbar } from "notistack";
import * as Action from "../../../../../../store/redux/terminal_reducer.js";

import Imgs from "./payments_images/giftOne.png";
import GiftImg from "./payments_images/giftOne.png";
import N1 from "../../images/n1.png";
import DebitSale from "../DebitSale";
import Payments from "../Payments";
import SuccessSound from "../../sounds/sold.wav";
import ErrorSound from "../../sounds/error.wav";
import RecentTransaction from "../RecentTransaction";
// import MultiplePayment from "../MultiplePayment";
import EventRoundedIcon from "@mui/icons-material/EventRounded";
import WorkspacePremiumRoundedIcon from "@mui/icons-material/WorkspacePremiumRounded";
import AccountCircleRoundedIcon from "@mui/icons-material/AccountCircleRounded";
import ForumRoundedIcon from "@mui/icons-material/ForumRounded";
import ShoppingCartIcon from "@mui/icons-material/ShoppingCart";
import AccountPay from "./payments_images/comps/Accounts.jsx";
import CloseOutlinedIcon from "@mui/icons-material/CloseOutlined";
import MultiplePayment from "./payments_images/comps/MultiplePayment.jsx";
import AccountPayment from "./payments_images/comps/AccountPayment.jsx";
import ChequePayment from "./payments_images/comps/ChequePayment.jsx";
import ComingSoon from "../../../../../../ComingSoon.jsx";

export function CashPayment({
  salesPayload,
  reactToPrintFn,
 setPaymentMethod,
  sales_reciept, 
  inventory
}) {
  const [cashCollected, setCashCollected] = useState(0);
  const {
    staffData,
    cart,
    registerId,
    updatesPayload,
    discount,
    customerName,
    customerId,
    setLoading,
    setOpenModal,
    secondaryFunction,
    setAlert,
    alert,
    subTotal,
    total,
    tax,
  } = salesPayload;

  // /////////////////////////////////////////////////////////
  // Cross Origin Resource Sharing CRUD - Functions
  // /////////////////////////////////////////////////////////
  const companyData = useSelector(
    (state) => state.clientFunction?.companiesDB?.clientData,
  );
  const { accessType } = useSelector((state) => state.clientFunction);

  const payload = {
    inventoryUpdatePayload: updatesPayload,
    soldItemPayload: {
      ...(salesPayload.shipping?.state ? { shipping: salesPayload.shipping } : {}),
      clientId: companyData?.clientId,
      dataType: "INCOME_TRANSACTION",
      inventoryId: inventory.inventoryId,
      registerId: registerId,
      saleId: salesPayload?.salesId, // invoice or receipt ID
      customerId: customerId,
      customer_name: customerName,
      soldItems: cart,
      totals: {
        cash: cashCollected,
        change: cashCollected - total,
        discount: discount,
        subtotal: subTotal,
        taxAmount: tax,
        total: total,
      },
      soldBy: {
        userId:
          accessType === "USER_ACCESS"
            ? staffData?.userId
            : companyData?.founder?.founderId,
        name:
          accessType === "USER_ACCESS"
            ? staffData?.personalInfo.firstName
            : companyData?.founder?.firstName,
      },
      payment: {
        method: "cash",
        payId: "",
        status: "paid",
      },
      status: "completed", // completed, refunded, cancelled
      createdAt: new Date(),
      updatedAt: "",
    },
  };

  // async function cashPaidSubmit() {
  //   try {
  //     setLoading(true);
  //     setPaymentMethod("Cash");
  //     setOpenModal(false);
  //     const response = await axios.post(
  //       `${process.env.REACT_APP_SERVER_SCRIPT_HOST}/client/${companyData?.clientId}/point_of_sales/payment/${"cash"}`,
  //       payload,
  //     );
  //     if (response?.data?.status === 200) {
  //       await new Audio(SuccessSound).play();
  //       setAlert({
  //         message: `Payment received! A total of ${cart.length} items have been successfully sold using Cash.`,
  //         type: "success",
  //       });
  //       setTimeout(() => {
  //         reactToPrintFn();
  //       }, 6100);
  //     } else {
  //       await new Audio(ErrorSound).play();
  //       setAlert({ message: "Failed to process cash payment!", type: "error" });
  //     }

  //     setLoading(false);
  //   } catch (error) {
  //     setLoading(false);
  //     await new Audio(ErrorSound).play();
  //     setAlert({
  //       message: "An error occurred while submitting the cash payment.",
  //       type: "error",
  //     });
  //     console.log(
  //       "An error occurred while submitting the cash payment.",
  //       error,
  //     );
  //   }
  // }

  async function executeEmitSaleSocketIO() {
    try {
      setLoading(true);
      setPaymentMethod("Cash");
      setOpenModal(false);

      salesPayload.submitSale({
        clientId: companyData?.clientId,
        paymentType: "cash",
        payload,
        uniCloud: companyData?.uniCloud,
        uniCloudPayload: {
          type: "cash_sale",
          heading: "New Cash Sale",
          description: `A new cash sale has been completed by ${
           accessType === "USER_ACCESS" ? staffData?.personalInfo?.firstName : companyData?.founder?.firstName
          }.`,
        }
      }); 
    } catch (error) {
      setLoading(false);

      await new Audio(ErrorSound).play();

      setAlert({
        message: "An error occurred while submitting the cash payment.",
        type: "error",
      });

      console.log(
        "An error occurred while submitting the cash payment.",
        error?.code || "REQUEST_FAILED",
      );
    }
  }

  function handleExecution() {
    if (Number.isFinite(cashCollected) && cashCollected >= total) {
      executeEmitSaleSocketIO();
    } else {
      setAlert({
        message: `Please Enter atleast Grand Total amount to perform cash transaction; otherwise use multiple payment`,
        type: "error",
      });
    }
  }

  return (
    // <div className="box">
    <div
      className="cashPaymentCont fx-cl space2"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="cashPaymenthead fx-ac fx-jc">
        <figure>&nbsp;</figure>
        <p>Cash Payment</p>
        <figure>&nbsp;</figure>
      </div>
      <div className="cashPaymentDiscCont">
        <div className="cashPaymentDisc fx-cl">
          <div className="cashPaymentRow">
            <div className="fx-ac spacem">
              <ShoppingCartIcon fontSize="large" /> <span>Products:</span>
            </div>
            <p>{cart?.length} items</p>
          </div>
          <div className="cashPaymentRow">
            <div className="fx-ac spacem">
              <EventRoundedIcon fontSize="large" /> <span>Grand Total:</span>
            </div>
            <p>
              <strong>₦ {total.toLocaleString()}</strong>
            </p>
          </div>
          <div className="cashPaymentRow">
            <div className="fx-ac spacem">
              <WorkspacePremiumRoundedIcon fontSize="large" />{" "}
              <span>Cash:</span>
            </div>
            <p> ₦ {cashCollected.toLocaleString()}</p>
          </div>
          <div className="cashPaymentRow ">
            <div className="fx-ac spacem">
              <AccountCircleRoundedIcon fontSize="large" /> <span>Change:</span>
            </div>
            <p style={{ color: "#ed826b", fontWeight: "bold" }}>
              {" "}
              ₦ {(cashCollected - total).toLocaleString()}
            </p>
          </div>
        </div>

        <div className="g g3 spacem">
          {[100, 200, 500, 1000, 2000, 5000, 10000, 20000, 50000].map((i) => {
            return (
              <figure
                className="cashPaymentNotes"
                onClick={() => setCashCollected(cashCollected + i)}
              >
                ₦{i.toLocaleString()}
              </figure>
            );
          })}
        </div>
      </div>
      <div className="cashPaymentButtom fx-cl space2 fx-jc">
        <div className="fx-ac">
          <input
            type="number"
            placeholder="Enter cash amount"
            value={cashCollected > 0 && cashCollected}
            onChange={(x) => setCashCollected(Number(x.target.value))}
          />
        </div>

        <div className="fx-ac space3 fx-jc">
          <button
            onClick={() => {
              secondaryFunction();
            }}
          >
            Cancel
          </button>
          <button
            onClick={() => {
              handleExecution();
            }}
          >
            Submit
          </button>
        </div>
      </div>
      <div className="discountFoot fx-ac fx-jc">
        <ForumRoundedIcon /> Highly secured and encryped by Universe Inventory
      </div> 
    </div>
  );
}

export function CreditSale({
  salesPayload,
  reactToPrintFn,
 setPaymentMethod,
  sales_reciept,
  inventory
}) {
  const dispatch = useDispatch();
  const [description, setDescription] = useState("");
  const [cashCollected, setCashCollected] = useState(0);
  const {
    cart,
    registerId,
    updatesPayload,
    discount,
    customerName,
    customerId,
    setLoading,
    setOpenModal,
    secondaryFunction,
    setAlert,
    alert,
    subTotal,
    total,
    tax,
  } = salesPayload;

  // /////////////////////////////////////////////////////////
  // Cross Origin Resource Sharing CRUD - Functions
  // /////////////////////////////////////////////////////////
  const companyData = useSelector(
    (state) => state.clientFunction?.companiesDB?.clientData,
  );
  const { accessType } = useSelector((state) => state.clientFunction);

  const { staffData } = useSelector(
    (state) => state.clientFunction?.companiesDB,
  );

  const payload = {
    inventoryUpdatePayload: updatesPayload,
    soldItemPayload: {
      clientId: companyData?.clientId,
      dataType: "DEBT_TRANSACTION",
      inventoryId: inventory.inventoryId,
      registerId: registerId,
      saleId: salesPayload?.salesId, // invoice or receipt ID
      customerId: customerId,
      customer_name: customerName,
      soldItems: cart,
      totals: {
        cash: cashCollected,
        change: cashCollected - total,
        discount: discount,
        subtotal: subTotal,
        taxAmount: tax,
        total: total,
      },
      soldBy: {
        userId:
          accessType === "USER_ACCESS"
            ? staffData?.userId
            : companyData?.founder?.founderId,
        name:
          accessType === "USER_ACCESS"
            ? staffData?.personalInfo.firstName
            : companyData?.founder?.firstName,
      },
      payment: {
        method: "credit",
        payId: "",
        status: "completed",
        description: description,
      },
      status: "completed", // completed, refunded, cancelled
      createdAt: new Date(),
      updatedAt: "",
    },
  };

  // async function executeCreditSale() {
  //   try {
  //     setLoading(true);
  //     setPaymentMethod("Cash");
  //     setOpenModal(false);
  //     const response = await axios.post(
  //       `${process.env.REACT_APP_SERVER_SCRIPT_HOST}/client/${companyData?.clientId}/point_of_sales/payment/${"credit"}`,
  //       payload,
  //     );
  //     if (response?.data?.status === 200) {
  //       await new Audio(SuccessSound).play();
  //       setAlert({
  //         message: `Debt recorded successfully! A total of ${cart.length} item(s) have been added to the customer's debt.`,
  //         type: "success",
  //       });
  //       dispatch(Action.deleteOnholdDispatch(sales_reciept));
  //       setTimeout(() => {
  //         reactToPrintFn();
  //       }, 6100);
  //     } else {
  //       await new Audio(ErrorSound).play();
  //       setAlert({
  //         message: "Unable to record the debt. Please try again.",
  //         type: "error",
  //       });
  //     }

  //     setLoading(false);
  //   } catch (error) {
  //     setLoading(false);
  //     await new Audio(ErrorSound).play();
  //     setAlert({
  //       message: "An error occurred while submitting the cash payment.",
  //       type: "error",
  //     });
  //   }
  // }
  async function executeEmitSaleSocketIO() {
    try {
      setLoading(true);
      setPaymentMethod("credit");
      setOpenModal(false);

      salesPayload.submitSale({
        clientId: companyData?.clientId,
        paymentType: "credit",
        payload,
        uniCloud: companyData?.uniCloud,
        uniCloudPayload: {
          type: "credit_sale",
          heading: "New Credit Sale",
          description: `A new credit sale has been completed by ${accessType === "USER_ACCESS" ? staffData?.personalInfo?.firstName : companyData?.founder?.firstName}.`,
        }
      });
    } catch (error) {
      setLoading(false);

      await new Audio(ErrorSound).play();

      setAlert({
        message: "An error occurred while submitting the credit payment.",
        type: "error",
      });

      console.log(
        "An error occurred while submitting the credit payment.",
        error?.code || "REQUEST_FAILED",
      );
    }
  }
  return (
    <div className="creditSalesCont" onClick={(e) => e.stopPropagation()}>
      <div className="creditSalesLeft fx-cl space2">
        <main className="g g2">
          <div className="fx-cl space2">
  <h3>Perform a Credit Sale.</h3>
  <p>
    Submit the transaction to record the sale and add the outstanding amount
    to the customer’s credit balance.
  </p>
  <p>
    This transaction will be recorded as a debt for <strong style={{textTransform: "uppercase"}}>{customerName}</strong>, and the
    outstanding amount will remain due until the customer makes a payment.
  </p>
</div>
        <div className="cashPaymentDisc fx-cl" style={{
  padding: '0 3rem',
  width: '37rem',
}}
>
          <div className="cashPaymentRow">
            <div className="fx-ac spacem">
              <ShoppingCartIcon fontSize="large" /> <span>Products:</span>
            </div>
            <p>{cart?.length} items</p>
          </div>
          <div className="cashPaymentRow">
            <div className="fx-ac spacem">
              <EventRoundedIcon fontSize="large" /> <span>Grand Total:</span>
            </div>
            <p>
              <strong>₦ {total.toLocaleString()}</strong>
            </p>
          </div>
          <div className="cashPaymentRow">
            <div className="fx-ac spacem">
              <WorkspacePremiumRoundedIcon fontSize="large" />{" "}
              <span>Discount:</span>
            </div>
            <p> ₦ {discount?.amount || 0.00} </p>
          </div>
          <div className="cashPaymentRow ">
            <div className="fx-ac spacem">
              <AccountCircleRoundedIcon fontSize="large" /> <span>Customer:</span>
            </div>
            <p style={{ color: "#ed826b", fontWeight: "bold" }}>
              {customerName}
                 
            </p>
          </div>
        </div>
        </main>
        <div className="fx-ac fx-jb space3">
         <input
  type="text"
  className="creditSaleDiscription"
  placeholder="Description.."
  value={description}
  onChange={(e) => setDescription(e.target.value)}
/>
          <button onClick={() => executeEmitSaleSocketIO()}>Complete Credit Sale</button>
        </div>
      </div>
      {/* <div className="creditSalesRight">
        <div className="fx-cl space2">
          <h3>Costomize this Credit Selling.</h3>
          <p>
            Inspiring kids to aim <strong>achieve</strong>
          </p>
          <button>Custome!</button>
        </div>
        <div>
          <img src={N1} alt="here" />
        </div>
      </div> */}
    </div>
  );
}
export function MultiPay({ salesPayload, setPaymentMethod, inventory }) {
  const companyData = useSelector(
    (state) => state.clientFunction?.companiesDB?.clientData,
  );
  const { accessType } = useSelector((state) => state.clientFunction);


  const {
    staffData,
    cart,
    updatesPayload,
    discount,
    customerName,
    customerId,
    setLoading,
    setOpenModal,
    secondaryFunction,
    setAlert,
    subTotal,
    total,
    tax,
  } = salesPayload;

  // /////////////////////////////////////////////////////////
  // Cross Origin Resource Sharing CRUD - Functions
  // /////////////////////////////////////////////////////////

   const [paymentOptions, setPaymentOptions] = useState([
    {
      id: "payment-1",
      amount: 250,
      method: "Cash",
      paymentAccount: "",
    },
  ]);

  const [paymentDescription, setPaymentDescription] = useState("");


  const payload = {
    inventoryUpdatePayload: updatesPayload,
    soldItemPayload: {
      ...(salesPayload.shipping?.state ? { shipping: salesPayload.shipping } : {}),
      clientId: companyData?.clientId,
      dataType: "INCOME_TRANSACTION",
      inventoryId: inventory.inventoryId,
      registerId: salesPayload.registerId,
      saleId: salesPayload.salesId, // invoice or receipt ID
      customerId: customerId,
      customer_name: customerName,
      soldItems: cart,
      totals: {
        cash: paymentOptions.filter((payment) => payment.method.toLowerCase() === "cash")
          .reduce((sum, payment) => sum + Number(payment.amount), 0),
        change: 0,
        discount: discount,
        subtotal: subTotal,
        taxAmount: tax,
        total: total,
      },
      soldBy: {
        userId:
          accessType === "USER_ACCESS"
            ? staffData?.userId
            : companyData?.founder?.founderId,
        name:
          accessType === "USER_ACCESS"
            ? staffData?.personalInfo.firstName
            : companyData?.founder?.firstName,
      },
      payment: {
        method: "multiple-pay", // cash, card, transfer, wallet
        payments: paymentOptions,
        description: paymentDescription,
        status: "paid",
      },
      status: "completed", // completed, refunded, cancelled
      createdAt: new Date(),
      updatedAt: "",
    },
  };

  // async function executeMultiPaySale() {
  //   try {
  //     setLoading(true);
  //     setOpenModal(false);
  //     setPaymentMethod("Multiple-Pay");
  //     const response = await axios.post(
  //       `${process.env.REACT_APP_SERVER_SCRIPT_HOST}/client/691a663dc9f64e6b9b8be48e/point_of_sales/payment/${"multi-pay-sale"}}`,
  //       payload,
  //     );
  //     if (response?.data?.status === 200) {
  //       await new Audio(SuccessSound).play();
  //       secondaryFunction();
  //       setAlert({
  //         message: `Payment received! A total of ${cart.length} items have been successfully sold using Cash.`,
  //         type: "success",
  //       });
  //     } else {
  //       await new Audio(ErrorSound).play();
  //       setAlert({ message: "Failed to process cash payment.", type: "error" });
  //     }

  //     setLoading(false);
  //   } catch (error) {
  //     setLoading(false);
  //     console.log(error);

  //     await new Audio(ErrorSound).play();
  //     setAlert({
  //       message: "An error occurred while submitting the cash payment.",
  //       type: "error",
  //     });
  //   }
  // }

  async function executeEmitSaleSocketIO() {
    try {
      if (paymentOptions.some((payment) => !Number.isFinite(Number(payment.amount)) || Number(payment.amount) <= 0)
          || Math.abs(paymentOptions.reduce((sum, payment) => sum + Number(payment.amount), 0) - total) >= 0.011) {
        setAlert({ type: "error", message: "Payment amounts must be positive and add up to the amount due." });
        return;
      }
      setLoading(true);
      setPaymentMethod("multiple-pay");
      setOpenModal(false);

      salesPayload.submitSale({
        clientId: companyData?.clientId,
        paymentType: "multiple-pay",
        payload,
         uniCloud: companyData?.uniCloud,
        uniCloudPayload: {
          type: "multiple_payment_sale",
  heading: "New Multiple Payment Sale",
  description: `A new sale using multiple payment methods has been completed by ${accessType === "USER_ACCESS" ? staffData?.personalInfo?.firstName : companyData?.founder?.firstName}.`,
  
        }
      });
    } catch (error) {
      setLoading(false);

      await new Audio(ErrorSound).play();

      setAlert({
        message: "An error occurred while submitting the multiple payment.",
        type: "error",
      });

      console.log(
        "An error occurred while submitting the multiple payment.",
        error?.code || "REQUEST_FAILED",
      );
    }
  }


  // -------------------------------------------------------------
  const paymentData = {
    options: paymentOptions,
    paymentDescription,
  };
 

  // -------------------------------------------------------------
  return (
    <div
      className="multiPaymentCont fx-cl space2"
      onClick={(e) => e.stopPropagation()}
    >
      <div className="fx-ac fx-jb space3">
                <div className="fx-cl space1">
  <h3 className="fs6 fw500">
    <span>Multiple Payment Options </span>{" "}
    <span style={{ color: "var(--primary-color)" }}>
      {" "}
      for the Transaction
    </span>
  </h3>

  <span className="fs3">
    Add and manage multiple payment methods for this transaction
  </span>
</div>
      
                <button
                  className="btnCloseacceptRtrn fx-ac fx-jc"
                  onClick={() => setOpenModal(false)}
                >
                  <CloseOutlinedIcon style={{ fontSize: "3.1rem" }} />
                </button>
              </div>
      <MultiplePayment
      options={paymentOptions}
      setOptions={setPaymentOptions}
      paymentDescription={paymentDescription}
      setPaymentDescription={setPaymentDescription}
      paymentAccounts={[
        {
          id: "bank-001",
          name: "GTBank - 0123456789",
        },
        {
          id: "bank-002",
          name: "Access Bank - 0987654321",
        },
        {
          id: "cash-account",
          name: "Cash Account",
        },
      ]}
    />
    <div className="fx-jb space2">
      <span>&nbsp;</span>
       <button
              className="multiple-payment__submit-button"
              onClick={() => executeEmitSaleSocketIO()}
            >
              Execute transaction
            </button>
    </div>
      {/* <MultiplePayment executeMultiPaySale={executeEmitSaleSocketIO} /> */}
    </div>
  );
}
export function Debit({ salesPayload, setPaymentMethod, inventory }) {
  const companyData = useSelector(
    (state) => state.clientFunction?.companiesDB?.clientData,
  );
  const { accessType } = useSelector((state) => state.clientFunction);
  const { enqueueSnackbar } = useSnackbar();

  const [cashCollected, setCashCollected] = useState(0);

  const {
    staffData,
    cart,
    updatesPayload,
    discount,
    customerName,
    customerId,
    setLoading,
    setOpenModal,
    secondaryFunction,
    setAlert,
    subTotal,
    total,
    tax,
  } = salesPayload;

  // /////////////////////////////////////////////////////////
  // Cross Origin Resource Sharing CRUD - Functions
  // /////////////////////////////////////////////////////////

  const payload = {
    inventoryUpdatePayload: updatesPayload,
    soldItemPayload: {
      clientId: companyData?.clientId,
      dataType: "INCOME_TRANSACTION",
      inventoryId: inventory.inventoryId,
      registerId: salesPayload.registerId,
      saleId: salesPayload.salesId, // invoice or receipt ID
      customerId: customerId,
      customer_name: customerName,
      soldItems: cart,
      totals: {
        cash: cashCollected,
        change: cashCollected - total,
        discount: discount,
        subtotal: subTotal,
        taxAmount: tax,
        total: total,
      },
      soldBy: {
        userId:
          accessType === "USER_ACCESS"
            ? staffData?.userId
            : companyData?.founder?.founderId,
        name:
          accessType === "USER_ACCESS"
            ? staffData?.personalInfo.firstName
            : companyData?.founder?.firstName,
      },
      payment: {
        method: "debit", // cash, card, transfer, wallet
        debitInfo: {},
        status: "paid",
      },
      status: "completed", // completed, refunded, cancelled
      createdAt: new Date(),
      updatedAt: "",
    },
  };

  // async function executeDebitPay() {

  //   try {
  //     setLoading(true);
  //     setOpenModal(false);
  //     setPaymentMethod("Debit");
  //     const response = await axios.post(
  //       `${process.env.REACT_APP_SERVER_SCRIPT_HOST}/client/691a663dc9f64e6b9b8be48e/point_of_sales/payment/${"debit-pay"}}`,
  //       payload,
  //     );
  //     if (response?.data?.status === 200) {
  //       await new Audio(SuccessSound).play();
  //       secondaryFunction();
  //       setAlert({
  //         message: `Payment received! A total of ${cart.length} items have been successfully sold using Cash.`,
  //         type: "success",
  //       });
  //     } else {
  //       await new Audio(ErrorSound).play();
  //       setAlert({ message: "Failed to process cash payment.", type: "error" });
  //     }

  //     setLoading(false);
  //   } catch (error) {
  //     setLoading(false);
  //     console.log(error);

  //     await new Audio(ErrorSound).play();
  //     setAlert({
  //       message: "An error occurred while submitting the cash payment.",
  //       type: "error",
  //     });
  //   }
  // }
  async function executeEmitSaleSocketIO() {
    try {
      setLoading(true);
      setPaymentMethod("debit");
      setOpenModal(false);

      salesPayload.submitSale({
        clientId: companyData?.clientId,
        paymentType: "debit",
        payload,
         uniCloud: companyData?.uniCloud,
        uniCloudPayload: {
           type: "debit_sale",
  heading: "New Debit Sale",
  description: `A new debit sale has been completed by ${accessType === "USER_ACCESS" ? staffData?.personalInfo?.firstName : companyData?.founder?.firstName}.`,
        }

         });
    } catch (error) {
      setLoading(false);

      await new Audio(ErrorSound).play();

      setAlert({
        message: "An error occurred while submitting the multiple payment.",
        type: "error",
      });

      console.log(
        "An error occurred while submitting the multiple payment.",
        error?.code || "REQUEST_FAILED",
      );
    }
  }
  return ( <ComingSoon onClose={setOpenModal} />);
}
export function Account({
  salesPayload,
  reactToPrintFn,
 setPaymentMethod,
  sales_reciept,
  inventory
}) {
  const dispatch = useDispatch();
  const [cashCollected, setCashCollected] = useState(0);
  const [selectedBankAccount, setSelectedBankAccount] =useState({})
  const {
    staffData,
    cart,
    registerId,
    updatesPayload,
    discount,
    customerName,
    customerId,
    setLoading,
    setOpenModal,
    secondaryFunction,
    setAlert,
    alert,
    subTotal,
    total,
    tax,
  } = salesPayload;

  const banksAccount = inventory?.banksAccount 

  // /////////////////////////////////////////////////////////
  // Cross Origin Resource Sharing CRUD - Functions
  // /////////////////////////////////////////////////////////
  const companyData = useSelector(
    (state) => state.clientFunction?.companiesDB?.clientData,
  );
  const { accessType } = useSelector((state) => state.clientFunction);
  const payload = {
    inventoryUpdatePayload: updatesPayload,
    soldItemPayload: {
      ...(salesPayload.shipping?.state ? { shipping: salesPayload.shipping } : {}),
      clientId: companyData?.clientId,
      dataType: "INCOME_TRANSACTION",
      inventoryId: inventory.inventoryId,
      registerId: registerId,
      saleId: salesPayload?.salesId, // invoice or receipt ID
      customerId: customerId,
      customer_name: customerName,
      soldItems: cart,
      totals: {
        cash: cashCollected,
        change: cashCollected - total,
        discount: discount,
        subtotal: subTotal,
        taxAmount: tax,
        total: total,
      },
      soldBy: {
        userId:
          accessType === "USER_ACCESS"
            ? staffData?.userId
            : companyData?.founder?.founderId,
        name:
          accessType === "USER_ACCESS"
            ? staffData?.personalInfo.firstName
            : companyData?.founder?.firstName,
      },
      payment: {
        method: "account",
        payId: "",
        status: "completed",
        account: selectedBankAccount,
      },
      status: "completed", // completed, refunded, cancelled
      createdAt: new Date(),
      updatedAt: "",
    },
  };

  // async function executeAcctPay() {
  //   try {
  //     setLoading(true);
  //     setPaymentMethod("Cash");
  //     setOpenModal(false);
  //     const response = await axios.post(
  //       `${process.env.REACT_APP_SERVER_SCRIPT_HOST}/client/${companyData?.clientId}/point_of_sales/payment/${"account"}`,
  //       payload,
  //     );
  //     if (response?.data?.status === 200) {
  //       await new Audio(SuccessSound).play();
  //       setAlert({
  //         message: `Cheque payment processed successfully! A total of ${cart.length} item(s) have been processed.`,
  //         type: "success",
  //       });
  //       dispatch(Action.deleteOnholdDispatch(sales_reciept));
  //       setTimeout(() => {
  //         reactToPrintFn();
  //       }, 6100);
  //     } else {
  //       await new Audio(ErrorSound).play();
  //       setAlert({
  //         message: "Unable to process the payment. Please try again.",
  //         type: "error",
  //       });
  //     }

  //     setLoading(false);
  //   } catch (error) {
  //     setLoading(false);
  //     await new Audio(ErrorSound).play();
  //     setAlert({
  //       message: "An error occurred while submitting the cash payment.",
  //       type: "error",
  //     });
  //   }
  // }

  async function executeEmitSaleSocketIO() {
    try {
      setLoading(true);
      setPaymentMethod("account");
      setOpenModal(false);

      salesPayload.submitSale({
        clientId: companyData?.clientId,
        paymentType: "account",
        payload,  
        uniCloud: companyData?.uniCloud,
        uniCloudPayload: {
        type: "account_sale",
        heading: "New Transfer Sale",
        description: `A new account transfer/POS sale has been completed by ${accessType === "USER_ACCESS" ? staffData?.personalInfo?.firstName : companyData?.founder?.firstName}.`,  }
      });
      
    } catch (error) {
      setLoading(false);

      await new Audio(ErrorSound).play();

      setAlert({
        message: "An error occurred while submitting the account payment.",
        type: "error",
      });

      console.log(
        "An error occurred while submitting the account payment.",
        error?.code || "REQUEST_FAILED",
      );
    }
  } 
  // return <AccountPay executeAcctPay={executeEmitSaleSocketIO} />;
  return <AccountPayment 
  executeAcctPay={executeEmitSaleSocketIO} 
  salesPayload={salesPayload} 
  banksAccount={banksAccount} 
  setSelectedBankAccount={setSelectedBankAccount} 
  selectedBankAccount={selectedBankAccount} 
  />
}
export function Cheque({
  salesPayload,
  reactToPrintFn,
 setPaymentMethod,
  sales_reciept,
  inventory
}) {
  const [chequePayment, setChequePayment] = useState({
  chequeNumber: "",
  bankName: "",
  accountName: "",
  chequeDate: "",
  branchName: "",
  payee: "",
  amountInWords: "",
  description: "",
  chequeImage: null,
});
  const dispatch = useDispatch();
  const [cashCollected, setCashCollected] = useState(0);
  const {
    staffData,
    cart,
    registerId,
    updatesPayload,
    discount,
    customerName,
    customerId,
    setLoading,
    setOpenModal,
    secondaryFunction,
    setAlert,
    alert,
    subTotal,
    total,
    tax,
  } = salesPayload;


  // /////////////////////////////////////////////////////////
  // Cross Origin Resource Sharing CRUD - Functions
  // /////////////////////////////////////////////////////////
  const companyData = useSelector(
    (state) => state.clientFunction?.companiesDB?.clientData,
  );
  const { accessType } = useSelector((state) => state.clientFunction);
  const payload = {
    inventoryUpdatePayload: updatesPayload,
    soldItemPayload: {
      ...(salesPayload.shipping?.state ? { shipping: salesPayload.shipping } : {}),
      clientId: companyData?.clientId,
      dataType: "INCOME_TRANSACTION",
      inventoryId: inventory.inventoryId,
      registerId: registerId,
      saleId: salesPayload?.salesId, // invoice or receipt ID
      customerId: customerId,
      customer_name: customerName,
      soldItems: cart,
      totals: {
        cash: cashCollected,
        change: cashCollected - total,
        discount: discount,
        subtotal: subTotal,
        taxAmount: tax,
        total: total,
      },
      soldBy: {
        userId:
          accessType === "USER_ACCESS"
            ? staffData?.userId
            : companyData?.founder?.founderId,
        name:
          accessType === "USER_ACCESS"
            ? staffData?.personalInfo.firstName
            : companyData?.founder?.firstName,
      },
      payment: {
        method: "cheque",
        payId: "",
        status: "completed",
        chequeData: chequePayment,
      },
      status: "completed", // completed, refunded, cancelled
      createdAt: new Date(),
      updatedAt: "",
    },
  }; 
  // async function executeChequePay() {
  //   try {
  //     setLoading(true);
  //     setPaymentMethod("Cash");
  //     setOpenModal(false);
  //     const response = await axios.post(
  //       `${process.env.REACT_APP_SERVER_SCRIPT_HOST}/client/${companyData?.clientId}/point_of_sales/payment/${"cheque"}`,
  //       payload,
  //     );
  //     if (response?.data?.status === 200) {
  //       await new Audio(SuccessSound).play();
  //       setAlert({
  //         message: `Cheque payment processed successfully! A total of ${cart.length} item(s) have been processed.`,
  //         type: "success",
  //       });
  //       dispatch(Action.deleteOnholdDispatch(sales_reciept));
  //       setTimeout(() => {
  //         reactToPrintFn();
  //       }, 6100);
  //     } else {
  //       await new Audio(ErrorSound).play();
  //       setAlert({
  //         message: "Unable to record the cheque payment. Please try again.",
  //         type: "error",
  //       });
  //     }

  //     setLoading(false);
  //   } catch (error) {
  //     setLoading(false);
  //     await new Audio(ErrorSound).play();
  //     setAlert({
  //       message: "An error occurred while submitting the cash payment.",
  //       type: "error",
  //     });
  //   }
  // }
  


  // -----------------------------------------------------
  

async function executeChequePay() {
  try {
    setLoading(true);
    setPaymentMethod("cheque");
    setOpenModal(false);

    const chequePayload = {
      ...payload,

      soldItemPayload: {
        ...payload.soldItemPayload,

        payment: {
          ...payload.soldItemPayload.payment,

          method: "cheque",
          payId: chequePayment?.chequeNumber || "",
          status: "pending",

          cheque: {
            chequeNumber: chequePayment?.chequeNumber,
            bankName: chequePayment?.bankName,
            accountName: chequePayment?.accountName,
            chequeDate: chequePayment?.chequeDate,
            branchName: chequePayment?.branchName,
            payee: chequePayment?.payee,
            amountInWords: chequePayment?.amountInWords,
            description: chequePayment?.description,
          },
        },
      },
    };

    salesPayload.submitSale({
      clientId: companyData?.clientId,
      paymentType: "cheque",
      payload: chequePayload,
      uniCloud: companyData?.uniCloud,
      uniCloudPayload: {
      type: "cheque_sale",
  heading: "New Cheque Sale",
  description: `A new cheque sale has been completed by ${accessType === "USER_ACCESS" ? staffData?.personalInfo?.firstName : companyData?.founder?.firstName}.`,  }
    });
  } catch (error) {
    setLoading(false);

    await new Audio(ErrorSound).play();

    setAlert({
      message:
        "An error occurred while submitting the cheque payment.",
      type: "error",
    });

    console.log(
      "An error occurred while submitting the cheque payment.",
      error?.code || "REQUEST_FAILED"
    );
  }
}
  return (
    <> 
    <ChequePayment
  amount={total}
  chequePayment={chequePayment}
  setChequePayment={setChequePayment}
  executeChequePay={executeChequePay}
  isSubmitting={setLoading}  
/>  </>
  );
}
export function Gifting({
  salesPayload,
  reactToPrintFn,
 setPaymentMethod,
  sales_reciept,
  inventory
}) {
  const dispatch = useDispatch();
  const [cashCollected, setCashCollected] = useState(0);
  const {
    staffData,
    cart,
    registerId,
    updatesPayload,
    discount,
    customerName,
    customerId,
    setLoading,
    setOpenModal,
    secondaryFunction,
    setAlert,
    alert,
    subTotal,
    total,
    tax,
  } = salesPayload;

  // /////////////////////////////////////////////////////////
  // Cross Origin Resource Sharing CRUD - Functions
  // /////////////////////////////////////////////////////////
  const companyData = useSelector(
    (state) => state.clientFunction?.companiesDB?.clientData,
  );
  const { accessType } = useSelector((state) => state.clientFunction);

  const payload = {
    inventoryUpdatePayload: updatesPayload,
    soldItemPayload: {
      ...(salesPayload.shipping?.state ? { shipping: salesPayload.shipping } : {}),
      clientId: companyData?.clientId,
      dataType: "GIFT_TRANSACTION",
      inventoryId: inventory.inventoryId,
      registerId: registerId,
      saleId: salesPayload?.salesId, // invoice or receipt ID
      customerId: customerId,
      customer_name: customerName,
      soldItems: cart,
      totals: {
        cash: cashCollected,
        change: cashCollected - total,
        discount: discount,
        subtotal: subTotal,
        taxAmount: tax,
        total: total,
      },
      soldBy: {
        userId:
          accessType === "USER_ACCESS"
            ? staffData?.userId
            : companyData?.founder?.founderId,
        name:
          accessType === "USER_ACCESS"
            ? staffData?.personalInfo.firstName
            : companyData?.founder?.firstName,
      },
      payment: {
        method: "gift",
        payId: "",
        status: "gifted",
      },
      status: "completed", // completed, refunded, cancelled
      createdAt: new Date(),
      updatedAt: "",
    },
  };

  // async function executeGift() {
  //   try {
  //     setLoading(true);
  //     setPaymentMethod("Cash");
  //     setOpenModal(false);
  //     const response = await axios.post(
  //       `${process.env.REACT_APP_SERVER_SCRIPT_HOST}/client/${companyData?.clientId}/point_of_sales/payment/${"gift"}`,
  //       payload,
  //     );
  //     if (response?.data?.status === 200) {
  //       await new Audio(SuccessSound).play();
  //       setAlert({
  //         message: `Gift sent successfully! A total of ${cart.length} items have been gifted.`,
  //         type: "success",
  //       });
  //       dispatch(Action.deleteOnholdDispatch(sales_reciept));
  //       setTimeout(() => {
  //         reactToPrintFn();
  //       }, 6100);
  //     } else {
  //       await new Audio(ErrorSound).play();
  //       setAlert({
  //         message: "Failed to send gift. Please try again.",
  //         type: "error",
  //       });
  //     }

  //     setLoading(false);
  //   } catch (error) {
  //     setLoading(false);
  //     await new Audio(ErrorSound).play();
  //     setAlert({
  //       message: "An error occurred while submitting the cash payment.",
  //       type: "error",
  //     });
  //   }
  // }

  // -------------------------------------------------------------------

  async function executeEmitSaleSocketIO() {
    try {
      setLoading(true);
      setPaymentMethod("gift");
      setOpenModal(false);

      salesPayload.submitSale({
        clientId: companyData?.clientId,
        paymentType: "gift",
        payload,
        uniCloud: companyData?.uniCloud,
        uniCloudPayload: {
          type: "gift_sale",
        heading: "New Gift Sale",
        description: `A new gift sale has been completed by ${accessType === "USER_ACCESS" ? staffData?.personalInfo?.firstName : companyData?.founder?.firstName}.`,
        userName: accessType === "USER_ACCESS" ? staffData?.personalInfo?.firstName : companyData?.founder?.firstName,
 }
      });
    } catch (error) {
      setLoading(false);

      await new Audio(ErrorSound).play();

      setAlert({
        message: "An error occurred while submitting the gift payment.",
        type: "error",
      });

      console.log(
        "An error occurred while submitting the gift payment.",
        error?.code || "REQUEST_FAILED",
      );
    }
  }
  return (
    <div
  className="giftingCardCont"
  onClick={(e) => e.stopPropagation()}
>
  <img src={GiftImg} alt="Gift sale" />

  <div className="giftingCard fx-cl">
    <div className="giftingCardTop fx-cl space2">
      <h3 className="fs6 fw500">
        Customize This Gift Sale
      </h3>

      <p>
        You’re about to make this transaction a gift for <strong>{customerName}</strong> and
       The selected items will be recorded as a gift and personalized with the gifting details provided below.
      </p>

      <button onClick={() => executeEmitSaleSocketIO()}>
        Confirm the Gift
      </button>
    </div>

    <div className="fx-cl giftingCardBtm">
      <p>
        Review the gift details before completing the transaction.
        The sale will be recorded as a gift transaction for easy
        tracking and reference.
      </p>
    </div>
  </div>
</div>
  );
}

export function PaymentLogs({ handleOnHold, setPaymentMethod }) {
  const { enqueueSnackbar } = useSnackbar();

  function handleSaveDraft() {
    enqueueSnackbar(`Draft added successfully`, {
      variant: "success",
      autoHideDuration: 3000,
      ContentProps: {
        style: { fontSize: "16px", fontWeight: "bold" },
      },
    });
  }
  return (
    <div
      className="paymentWrapper fx-cl space2"
      onClick={(e) => e.stopPropagation()}
    >
      <Payments />
    </div>
  );
}
